import { useContext } from 'react';
import { I18nContext, type I18nValue } from './I18nProvider.js';

/** The translator for the current UI locale. Throws outside the provider —
 *  a silently English screen is harder to notice than a crash in dev. */
export function useI18n(): I18nValue {
  const value = useContext(I18nContext);
  if (!value) throw new Error('useI18n must be used inside <I18nProvider>');
  return value;
}
